import { Component, input, linkedSignal } from '@angular/core';

@Component({
    selector: 'app-animated-value',
    templateUrl: './animated-value.component.html',
    styleUrl: './animated-value.component.css',
    host: { '[class.animated]': 'animated()' },
})
export class AnimatedValueComponent {
    /** Null renders the placeholder — the swap out of it is the initial load, which must land without moving. */
    readonly value = input.required<string | number | null>();

    protected readonly animated = linkedSignal<string | number | null, boolean>({
        source: this.value,
        computation: (current, previous) => previous !== undefined && previous.source !== null,
    });
}
